import SiparislerService from "../../../services/SiparislerService";

export default {
  namespaced: true,
  state: () => ({
    siparisListesi: {
      list: [],
      count: 0
    },
    siparisListesiLoading: false,
    orderRelations: null,
    orderRelationsLoading: false
  }),
  mutations: {
    setSiparisListesi: (state, list) => {
      state.siparisListesi = list;
    },
    setSiparisListesiLoading: (state, list) => {
      state.siparisListesiLoading = list;
    },
    resetSiparisListesi: (state) => {
      state.siparisListesi = {
        list: [],
        count: 0
      };
    },
    setOrderRelations: (state, data) => {
      state.orderRelations = data;
    },
    setOrderRelationsLoading: (state, status) => {
      state.orderRelationsLoading = status;
    }
  },
  actions: {
    siparisListesi: ({ commit }, data) => {
      commit("setSiparisListesiLoading", true);
      commit("resetSiparisListesi");
      return new Promise((resolve, reject) => {
        SiparislerService.siparisListesi(data)
          .then((res) => {
            commit("setSiparisListesi", res.data);
            commit("setSiparisListesiLoading", false);
            resolve(res);
          })
          .catch((err) => {
            commit("setSiparisListesiLoading", false);
            reject(err);
          });
      });
    },
    getOrderRelations({ commit, state }) {
      if (state.orderRelations) return state.orderRelations;

      commit("setOrderRelationsLoading", true);
      return SiparislerService.orderStatusRelations().then(({ status, data }) => {
        if (status === 200) {
          commit("setOrderRelations", data);
        }
        commit("setOrderRelationsLoading", false);
        return data;
      }).catch(() => {
        commit("setOrderRelationsLoading", false);
      });
    }
  }
};